import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import {
  Home,
  Devhub,
  Faq,
  Buy,
  Search,
  NotFound,
  Article,
  SurvivorGamez
} from "../pages";

import {
  HOME_PAGE_NAME,
  DEVHUB_PAGE_NAME,
  FAQ_PAGE_NAME,
  BUY_PAGE_NAME,
  SEARCH_PAGE_NAME,
  NOT_FOUND_PAGE_NAME,
  ARTICLE_PAGE,
  ARTICLE_PAGE_PREVIEW,
  SURVIVOR_GAMEZ
} from "./pageNameConstants";

let routes = [
  {
    path: "/blog/dayz-1-0-launches-december-13th-on-steam",
    beforeEnter() {
      window.location =
        "https://dayz.com/article/general/dayz-1-0-launches-december-13th-on-steam";
    }
  },
  {
    path: "/",
    name: HOME_PAGE_NAME,
    component: Home
  },
  {
    path: "/dev-hub",
    name: DEVHUB_PAGE_NAME,
    component: Devhub,
    meta: { subHeader: true }
  },
  {
    path: "/faq",
    name: FAQ_PAGE_NAME,
    component: Faq
  },
  {
    path: "/buy",
    name: BUY_PAGE_NAME,
    component: Buy
  },
  {
    path: "/sg-alpha",
    name: SURVIVOR_GAMEZ,
    component: SurvivorGamez,
    meta: {
      onlyView: true,
      noSplash: true
    }
  },
  {
    path: "/search",
    name: SEARCH_PAGE_NAME,
    component: Search
  },
  {
    path: "/article/:category/:slug",
    name: ARTICLE_PAGE,
    component: Article,
    meta: { subHeader: true }
  },
  {
    path: "/article/preview",
    name: ARTICLE_PAGE_PREVIEW,
    component: Article,
    meta: { subHeader: true }
  },
  {
    path: "/404",
    alias: "*",
    name: NOT_FOUND_PAGE_NAME,
    component: NotFound,
    meta: { onlyView: true }
  }
];

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition;
  } else {
    const position = {
      x: 0,
      y: 0
    };

    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash;
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0;
      position.y = 0;
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position;
  }
};

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior
});

export default router;
